import axios from 'axios';
import { FETCH_HOME_PAGE_DATA } from './api.config';
import normalizeData from './normalizeData';

export default async function () {
    try {
        const { data } = await axios({
            method: 'get',
            url: FETCH_HOME_PAGE_DATA,
        });
        return normalizeData(data);
    } catch (message) {
        // @todo log errors
        throw new Error('We dont have data for homepage');
    }
}
